// extracted by mini-css-extract-plugin
module.exports = {"clamp2":"BlogPostCard_clamp2__6Co9T"};